import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials, type Testimonial } from '../data/testimonials';
function Stars({
  size = 'h-3.5 w-3.5'
}: {
  size?: string;
}) {
  return <span className="flex gap-0.5" role="img" aria-label="Rated 5 out of 5" data-id="element-264" data-mp="3fze4jzypl7wq">
      {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className={`${size} fill-gold text-gold`} aria-hidden="true" data-id="element-265" data-mp="3b1ckbbpjr2jo" />)}
    </span>;
}
function Author({
  item
}: {
  item: Testimonial;
}) {
  return <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-266" data-mp="31zwc9am7fcim">
      <img src={item.avatar} alt={`Photo of ${item.author}`} width={48} height={48} loading="lazy" className="h-12 w-12 flex-none rounded-full object-cover object-[50%_28%] ring-2 ring-gold/50" data-id="element-267" data-mp="31yl6j5977uov" />
      <span className="min-w-0 leading-tight" data-id="element-268" data-mp="v9yfpaj1vt9q">
        <span className="block text-sm font-semibold text-white" data-id="element-269" data-mp="v8nb58hs6hhk">{item.author}</span>
        <span className="mt-0.5 block text-xs text-white/60" data-id="element-270" data-mp="qavb1r6zfp2a">{item.role}</span>
      </span>
    </figcaption>;
}
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  const side = rest.slice(0, 2);
  const bottom = rest.slice(2);
  return <section aria-labelledby="testimonials-heading" className="w-full bg-plum" data-id="element-271" data-mp="78aepqyx89mi">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-272" data-mp="c6llfstx640i">
        <div className="flex flex-col items-center text-center" data-id="element-273" data-mp="c73p3aiwvkig">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-274" data-mp="zxh9cev98f2h">
            From GMs who run paid tables
          </p>
          <h2 id="testimonials-heading" className="mt-3 max-w-3xl font-display font-semibold text-white text-3xl leading-tight sm:text-5xl" data-id="element-275" data-mp="14xlp22oc95rn">
            Their players keep asking <span className="text-gold" data-id="element-276" data-mp="v3d0tr6cbyza">“when’s the next one?”</span>
          </h2>
          <div className="mt-5 flex items-center gap-3" data-id="element-277" data-mp="1itzatnzwntbx">
            <div className="flex -space-x-2.5" data-id="element-278" data-mp="1nma8ek76b31b">
              {testimonials.map(t => <img key={t.author} src={t.avatar} alt="" width={36} height={36} loading="lazy" className="h-9 w-9 rounded-full object-cover object-[50%_28%] ring-2 ring-plum" data-id="element-279" data-mp="1xiisiwe1nkip" />)}
            </div>
            <div className="text-left leading-tight" data-id="element-280" data-mp="1jkc2u3j90qu4">
              <Stars data-id="element-281" data-mp="1ejejvoqezsrk" />
              <p className="mt-1 text-[13px] text-white/70" data-id="element-282" data-mp="1ekpplu3f7alb">
                <span className="font-semibold text-white" data-id="element-283" data-mp="19rwm19jou8at">4.9/5</span> from 300+ Game Masters
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 grid gap-4 lg:grid-cols-[1.35fr_1fr]" data-id="element-284" data-mp="14r8veozdfth4">
          <figure className="flex flex-col overflow-hidden rounded-3xl border border-gold/40 bg-plum-card sm:flex-row lg:flex-col" data-id="element-285" data-mp="10t1dvrx32o4v">
            <img src={featured.avatar} alt={`${featured.author} at his game table`} width={1024} height={1024} loading="lazy" className="aspect-[4/3] w-full object-cover object-[50%_30%] sm:aspect-auto sm:w-2/5 lg:aspect-[16/9] lg:w-full" data-id="element-286" data-mp="vuq2hcr545kj" />
            <div className="flex flex-1 flex-col p-6 sm:p-8" data-id="element-287" data-mp="3cek3xjmska1g">
              <Stars size="h-4 w-4" data-id="element-288" data-mp="3cczajxc7qx56" />
              <blockquote className="mt-4 font-display text-xl font-medium leading-snug text-white sm:text-2xl" data-id="element-289" data-mp="3gh6xpq30w51a">
                “{featured.quote}”
              </blockquote>
              <Author item={featured} data-id="element-290" data-mp="2opip9end82nq" />
            </div>
          </figure>

          <div className="grid gap-4" data-id="element-291" data-mp="2onenb2911dq3">
            {side.map(item => <figure key={item.author} className="flex flex-col rounded-3xl border border-plum-line bg-plum-card p-6" data-id="element-292" data-mp="2sqb0uejpmjn6">
                <Stars data-id="element-293" data-mp="210gaqfo12pxg" />
                <blockquote className="mt-3 text-[15px] leading-relaxed text-white/85" data-id="element-294" data-mp="20z55sciujc4r">
                  “{item.quote}”
                </blockquote>
                <Author item={item} data-id="element-295" data-mp="1lwwp1zmquykm" />
              </figure>)}
          </div>
        </div>

        <div className="mt-4 grid gap-4 md:grid-cols-3" data-id="element-296" data-mp="1gxtx9gvryoul">
          {bottom.map(item => <figure key={item.author} className="flex flex-col rounded-3xl border border-plum-line bg-plum-card p-6" data-id="element-297" data-mp="1vmpz2w78n5mr">
              <Stars data-id="element-298" data-mp="1quf1hzzyzvxd" />
              <blockquote className="mt-3 text-[15px] leading-relaxed text-white/85" data-id="element-299" data-mp="1qtwwadvby7db">
                “{item.quote}”
              </blockquote>
              <Author item={item} data-id="element-300" data-mp="1zp35lmtt77kl" />
            </figure>)}
        </div>
      </div>
    </section>;
}